const Field = require("components/forms/Field");
const TagsAbstract = require("components/abstract/Tags");

class Tags extends TagsAbstract {

	render() {
		return (
			<Field tag="div" className={this.className} {...this.inputProps}>
				{this.renderTags()}
				{this.renderHiddenInputs()}
			</Field>
		);
	}

	renderHiddenInputs() {
		if (typeof this.props.name !== "string") {
			return;
		}

		// Add control (so it forces a required trigger) if there are no tags
		if (this.state.value.length === 0) {
			return (<input type="hidden" name={this.props.name}/>);
		}

		return this.state.value.map(tag => {
			return (<input type="hidden" key={tag.id} name={`${this.props.name}[]`} value={tag.id}/>);
		});
	}

}

module.exports = Tags;


// WEBPACK FOOTER //
// ./resources/js/components/forms/Tags.js